/* unplugin-vue-components disabled */import script from "./left-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./left-user.vue?vue&type=script&lang=ts&setup=true"

import "./left-user.vue?vue&type=style&index=0&id=22192718&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22192718"]])

export default __exports__